"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionarySpecs = exports.DictionarySpecsSerializer = void 0;
// MIT © 2017 azu
var prototype_1 = require("@immutable-array/prototype");
var DictionarySpec_1 = require("./DictionarySpec");
var ddd_base_1 = require("ddd-base");
exports.DictionarySpecsSerializer = {
    fromJSON: function (specs) {
        if (specs === void 0) { specs = []; }
        return new DictionarySpecs({
            specs: specs.map(function (spec) { return new DictionarySpec_1.DictionarySpec(spec); })
        });
    },
    toJSON: function (entity) {
        return entity
            .getSpecList()
            .filter(function (spec) { return spec.isFilled; })
            .map(function (spec) {
            return {
                from: spec.from,
                to: spec.to
            };
        });
    }
};
/**
 * Collection of DictionarySpec
 */
var DictionarySpecs = /** @class */ (function (_super) {
    __extends(DictionarySpecs, _super);
    function DictionarySpecs(props) {
        var _this = _super.call(this, props) || this;
        _this.specs = _this.props.specs;
        return _this;
    }
    // read
    DictionarySpecs.prototype.getSpecList = function () {
        return this.specs;
    };
    DictionarySpecs.prototype.getFilledSpecList = function () {
        return this.specs.filter(function (spec) { return spec.isFilled; });
    };
    DictionarySpecs.prototype.getActualPatterns = function () {
        return this.getSpecList().map(function (spec) { return spec.from; });
    };
    DictionarySpecs.prototype.getExpectedResults = function () {
        return this.getSpecList().map(function (spec) {
            if (spec.isInvalid && spec.error) {
                return spec.error.message;
            }
            else {
                return spec.to;
            }
        });
    };
    // write
    DictionarySpecs.prototype.add = function (spec) {
        return new DictionarySpecs({
            specs: this.specs.concat(spec)
        });
    };
    DictionarySpecs.prototype.update = function (oldSpec, newSpec) {
        var index = this.specs.findIndex(function (target) {
            return target.equals(oldSpec);
        });
        if (index === -1) {
            return this;
        }
        var newSpecs = prototype_1.splice(this.specs, index, 1, newSpec);
        return new DictionarySpecs({
            specs: newSpecs
        });
    };
    DictionarySpecs.prototype.remove = function (spec) {
        var index = this.specs.findIndex(function (target) {
            return target.equals(spec);
        });
        if (index === -1) {
            return this;
        }
        return new DictionarySpecs({
            specs: prototype_1.splice(this.specs, index, 1)
        });
    };
    DictionarySpecs.prototype.findByActual = function (oldSpecActual) {
        return this.specs.find(function (target) {
            return target.from === oldSpecActual;
        });
    };
    return DictionarySpecs;
}(ddd_base_1.ValueObject));
exports.DictionarySpecs = DictionarySpecs;
//# sourceMappingURL=DictionarySpecs.js.map


//////////////////
// WEBPACK FOOTER
// ../domain/lib/Dictionary/DictionarySpecs.js
// module id = 171
// module chunks = 0